import clsx from 'clsx';
import type React from 'react';

import { Container, Content, CustomBg, PageWrapper, StyledSidebarPusher } from './MfWrapper.styles';

export function MFWrapper({
    children,
    iframe,
    className,
}: {
    children: React.ReactNode;
    iframe?: boolean;
    className?: string;
}) {
    const isWindows = navigator.userAgent.indexOf('Windows') !== -1;

    return (
        <StyledSidebarPusher $compensateScrollbar={isWindows}>
            <PageWrapper className={clsx('mf-wrapper__root', className)}>
                <Content className="mf-wrapper__pusher">
                    <Container $iframe={iframe} className="mf-wrapper__main">
                        {children}
                        {iframe && <CustomBg />}
                    </Container>
                </Content>
            </PageWrapper>
        </StyledSidebarPusher>
    );
}
